import _ from 'lodash';

import { arrayToDictionary } from '../utils/array';

export function searchOrdersByIdPart(orders, idPart) {
    const trimmed = idPart && idPart.trim();
    if (!trimmed || !trimmed.length) return orders;
    return orders.filter(order => order.id.indexOf(trimmed) !== -1);
}

const newOrderStatuses = arrayToDictionary(['new']);
const inProgressOrderStatuses = arrayToDictionary(['assigned', 'onWayToDelivery', 'waitingForPickup', 'pickedUp', 'partlyPickedUp', 'waitingForReturn']);
const historyOrderStatuses = arrayToDictionary(['canceled', 'delivered', 'returned']);

function filterByStatus(orders, statuses) {
    return _(orders)
        .filter(order => statuses[order.orderStatus])
        .sortBy('createdAt', 'expectedPickUpTime')
        .reverse()
        .value();
}

function getNewOrders(orders) {
    return filterByStatus(orders, newOrderStatuses);
}

function getInProgressOrders(orders) {
    return filterByStatus(orders, inProgressOrderStatuses);
}

function getHistoryOrders(orders){
    return filterByStatus( orders, historyOrderStatuses);
}

export function searchOrders(orders, search) {
    const filteredOrders = searchOrdersByIdPart(orders, search);
    return {
        newOrders: getNewOrders(filteredOrders),
        inProgress: getInProgressOrders(filteredOrders),
        history: getHistoryOrders(filteredOrders)
    };
}


// WEBPACK FOOTER //
// ./src/businessLogic/onDemandOrdersFilter.js